module.exports = __webpack_public_path__ + "static/id-4a7d6d72a5cdfbe5725efc8830c42bc2.mp4";